import FormatUtil from '../util/FormatUtil';

export interface IResultUserItem{
    PK: string;
    USERNAME: string;
    EMAIL: string;
    PHONE_NUMBER:string;
    USER_ROLE:string;
    PASSWORD?:string;
    SECURITY_GROUP_ID?:string;
}

export interface IUserData {
    PK: string;
    USERNAME: string;
    EMAIL: string;
    PHONE_NUMBER:string;
    USER_ROLE:string;
    PASSWORD?:string;
    COMPANYID?:string;
    SECURITY_GROUP_ID?:string;
}


export function convertResultUserItem_To_IUserataItem($input:IResultUserItem){

    let PK:string = $input.PK;
    let USERNAME:string = $input.USERNAME || "";
    let EMAIL:string = $input.EMAIL;
    let USER_ROLE:string = $input.USER_ROLE || "";
    let PASSWORD:string = "";
    let COMPANYID:string = "";
    let SECURITY_GROUP_ID = $input.SECURITY_GROUP_ID;

    let PHONE_NUMBER:string = $input.PHONE_NUMBER?FormatUtil.phoneNumber($input.PHONE_NUMBER) || "":"";
    
    let newData:IUserData = {
        PK,
        USERNAME,
        EMAIL,
        PHONE_NUMBER,
        USER_ROLE,
        PASSWORD,
        COMPANYID,
        SECURITY_GROUP_ID
    }

    


    return newData;

}

export function handleSetIUserData($data:IResultUserItem[]):IUserData[]{
    return $data.map(convertResultUserItem_To_IUserataItem);
}
